
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.969 1.333C4.31 1.333 1.333 4.324 1.333 8A6.674 6.674 0 008 14.667 6.674 6.674 0 0014.667 8c0-3.676-3.005-6.667-6.698-6.667zm.698 10H7.333V10h1.334v1.333zm0-2.666H7.333v-4h1.334v4z"}})])
          )
        }
      }
    